import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { ProfileGuard } from '@guards/profile/profile.guard';
import { LocalesResolver } from 'core/resolvers';
import { GamesComponent } from './games/games.component';
import { GameCreateComponent } from './game-create/game-create.component';
import { GameDetailComponent } from './game-detail/game-detail.component';

const gamesRoutes: Routes = [
  {
    path: 'games',
    title: 'games.label',
    resolve: {
      locales: LocalesResolver
    },
    children: [
      {
        path: '',
        title: '',
        component: GamesComponent,
        canActivate: [ProfileGuard],
        data: { action: 'games.list' }
      },
      {
        path: 'new',
        title: 'games.add',
        component: GameCreateComponent,
        canActivate: [ProfileGuard],
        data: { action: 'games.create' }
      },
      {
        path: ':id',
        title: ':id',
        component: GameDetailComponent,
        canActivate: [ProfileGuard],
        data: { action: 'games.detail', preloader: 'secondary' }
      }
    ]
  }
];

@NgModule({
  imports: [RouterModule.forChild(gamesRoutes)],
  exports: [RouterModule]
})
export class GamesRoutingModule {}
